import React, { type FC, memo } from 'react'
import { Button, Flex } from 'antd'

import { IDrawerFooterBlock } from '../../constants/types/common'
import { ButtonWithTooltip } from './ButtonWithTooltip'

export const DrawerFooterBlock: FC<IDrawerFooterBlock> = memo(({ tooltipText = '', confirm, cancel }) => (
  <Flex
    justify='flex-end'
    gap={8}
    className='drawer-footer-block'>
    {cancel && (
      <Button
        color='primary'
        variant='outlined'
        children='Cancel'
        {...cancel}
      />
    )}
    <ButtonWithTooltip
      tooltipText={tooltipText}
      type='primary'
      children='Done'
      {...confirm}
    />
  </Flex>
))
